<template>
  <router-view />
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/user";

// 应用启动时从 localStorage 恢复用户信息到 store
const userStore = useUserStore();
userStore.initUserInfo();
</script>

<style>
html, body, #app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>
